<script>
    import { TheMask } from 'vue-the-mask'

    export default {
        props: ["value", "validate", "disabled", "saved", "name"],
        data() {
            return {
                phone: this.value || "",
                changed: false
            }
        },
        components: {
            TheMask
        },
        watch: {
            value(val) {
                this.phone = val;
            },
            saved(val) {
                if(val) {
                    this.changed = false;
                }
            }
        }
    }
</script>

<template>
    <the-mask type="tel" v-model="phone" v-validate="validate" @input="$emit('input', phone)" @change="$emit('change', phone)" mask="(###) ###-####" :disabled="disabled" 
        @change.native="changed = true" :class="{ changed: changed, 'disabled-mask': disabled }" :name="name"/>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .disabled-mask {
        opacity: 1;
        color: @ibe-text--dark-gray;
        background-color: @inputDisabledBackground;
        font-weight: 500;
    }
</style>